import { api } from "../api";

export default async function singleAnalysis(
  encodedId: string,
  isBackground: boolean
) {
  try {
    const { status, data } = await api.get(
      `/analysis/${encodedId}${isBackground ? "?isBackground=1" : ""}`
    );

    if (status === 200) {
      return data;
    }

    return null;
  } catch (err: any) {
    const status = err?.response?.status;
    const msg = err?.response?.data?.msg;

    if (status === 410 && msg === "Asset is inactive") {
      window.location.replace("/unavailable-resource/asset");
    }

    return null;
  }
}
